import { Container, Texture, Sprite, Text, Graphics } from 'pixi.js';
import {
  chartBlockStyles,
  fastTradeAnimationSourceNames,
  gameImages,
  marketTypes,
} from '../../fastTradeCore/constants';
import { isMobile } from '../../../../core/helpers/isMobile';
import { Spine } from '../../../../core/classes/spine';
import { mathConfig, mathJS } from '../../../../core/helpers/mathFormat';
import { applicationStore } from '../../../../store/applicationStore';

const { defaultBlock, defaultArrow, overDefault, underDefault, overArrow, underArrow } = gameImages;
const {
  oddTextStyleWeb,
  oddTextStyleMob,
  oddTextY,
  oddTextX,
  actionOddTextX,
  actionOddTextY,
  amountTextStyleMob,
  amountTextStyleWeb,
  amountTextX,
  amountTextY,
  // currencyImgY,
  currencyScale,
  actionAmountTextX,
  actionAmountTextY,
  actionContainerOverX,
  actionContainerUnderX,
  actionContainerY,
  actionNameX,
  actionNameY,
  actionArrowX,
  actionArrowY,
  actionNameStyle,
} = chartBlockStyles;

export class BetBlock {
  constructor(betBlockItem) {
    this.roundId = betBlockItem.roundId;
    if (betBlockItem?.type === 'action') {
      this.initAction(betBlockItem);
    } else {
      this.init(betBlockItem);
    }
  }

  initAction(betBlockItem) {
    this.betBlockItem = betBlockItem;
    this.container = new Container();
    this.bgSprite = new Sprite(
      Texture.from(betBlockItem.marketType === marketTypes.over ? overDefault : underDefault)
    );
    this.bgSprite.interactive = true;
    this.bgSprite.buttonMode = true;
    this.bgSprite.cursor = 'pointer';
    this.container.x =
      betBlockItem.marketType === marketTypes.over ? actionContainerOverX : actionContainerUnderX;
    this.container.y = actionContainerY;
    this.createOddText(actionOddTextX, actionOddTextY);
    this.createActionName();
    const amount = +mathJS.format(betBlockItem.amount * betBlockItem.odd, mathConfig);
    this.createAmountText(amount, actionAmountTextX, actionAmountTextY);
    this.bgSprite.addChild(this.oddText, this.actionName, this.amountText);
    this.createWinSpine(true);
    this.container.addChild(this.winSpine, this.bgSprite);
  }

  init(betBlockItem) {
    this.betBlockItem = betBlockItem;
    this.container = new Container();
    this.border = new Graphics();
    this.bgSprite = new Sprite(
      Texture.from(betBlockItem.roundId === 'row' ? defaultArrow : defaultBlock)
    );
    this.border.visible = false;
    this.bgSprite.interactive = true;
    this.bgSprite.buttonMode = true;
    this.bgSprite.cursor = 'pointer';
    if (betBlockItem.roundId === 'row') {
      this.container.addChild(this.bgSprite, this.border);
    } else {
      const amount = +mathJS.format(betBlockItem.amount * betBlockItem.odd, mathConfig);
      this.createOddText(oddTextX, oddTextY);
      this.createAmountText(amount, amountTextX, amountTextY);
      // this.createCurrencyImg();
      this.bgSprite.addChild(this.oddText, this.amountText);
      this.createWinSpine();
      this.container.addChild(this.winSpine, this.bgSprite, this.border);
    }
  }

  createOddText(textX, textY) {
    const style = isMobile() ? oddTextStyleMob : oddTextStyleWeb;
    this.oddText = new Text(`x ${this.betBlockItem.odd}`, style);
    this.oddText.x = textX;
    this.oddText.y = textY;
  }

  createActionName() {
    const { gameCanvasTranslations } = applicationStore;
    const name =
      this.betBlockItem.marketType === marketTypes.over
        ? gameCanvasTranslations.over
        : gameCanvasTranslations.under;
    this.actionName = new Text(name, actionNameStyle);
    this.actionArrow = new Sprite(
      Texture.from(this.betBlockItem.marketType === marketTypes.over ? overArrow : underArrow)
    );
    this.actionName.x = actionNameX;
    this.actionName.y = actionNameY;
    this.actionArrow.x = this.actionName.width / 2 - actionArrowX;
    this.actionArrow.y = actionArrowY;
    this.actionName.addChild(this.actionArrow);
  }

  createAmountText(amount, textX, textY) {
    const style = isMobile() ? amountTextStyleMob : amountTextStyleWeb;
    this.amountText = new Text(amount || '', style);
    this.amountText.x = textX;
    this.amountText.y = textY;
  }

  createCurrencyImg() {
    this.currencyImg = new Sprite();
    this.currencyImg.scale.set(currencyScale);
    // this.currencyImg.y = currencyImgY;
  }

  createWinSpine(isAction) {
    this.winSpine = new Spine({ key: fastTradeAnimationSourceNames.win });
    this.winSpine.position = {
      x: isMobile() && isAction ? 80 : this.bgSprite.width / 2,
      y: isMobile() && isAction ? 26 : this.bgSprite.height / 2,
    };
  }
}
